import { NgModule, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule, Routes } from '@angular/router'

import { authGuard, authMatchGuard } from './modules/auth/auth.guard'
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component'
import { BlockedUserComponent } from './core/components/blocked-user/blocked-user.component'
import { PageFatalErrorComponent } from './core/components/page-fatal-error/page-fatal-error.component'
import { adminGuard, clientGuard, resellerGuard } from '@core/guards/role.guard'
import { termsGuard } from './core/guards/terms-agreement.guard'
import { FeatureFlagService } from '@core/services/feature-flag.service'

const appRoutes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'track',
    loadChildren: () => import('./modules/vehicle-tracking/vehicle-tracking.module').then((m) => m.VehicleTrackingModule),
  },
  {
    path: '',
    canMatch: [authMatchGuard],
    canActivate: [authGuard],
    children: [
      {
        path: 'admin',
        canActivate: [adminGuard, termsGuard],
        loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'client',
        canActivate: [clientGuard, termsGuard],
        loadChildren: () => import('./modules/client/client.module').then((m) => m.ClientModule),
      },
      {
        path: 'v2/client',
        canMatch: [() => inject(FeatureFlagService).uiV2],
        canActivate: [clientGuard, termsGuard],
        loadChildren: () => import('./modules/client-v2/client-v2.module').then((m) => m.ClientV2Module),
      },
      { path: 'user', loadChildren: () => import('./modules/user/user.module').then((m) => m.UserModule) },
      {
        path: 'reseller',
        canActivate: [resellerGuard, termsGuard],
        loadChildren: () => import('./modules/reseller/reseller.module').then((m) => m.ResellerModule),
      },
    ],
  },
  { path: 'blocked', component: BlockedUserComponent },
  { path: 'error-page', component: PageFatalErrorComponent },
  { path: '**', component: PageNotFoundComponent },
]

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forRoot(appRoutes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
